import { classNames } from 'shared/lib/classNames/classNames'
import logo from 'shared/assets/MineCards-Logo-Rounded.svg'
import cls from '../InstallWidget.module.scss'
import { IconBadge, IconBadgeTone, SuccessIcon } from 'shared/ui/Icon'

export const Installed = () => {
    return (
        <div className={classNames(cls.InstallWidget, {}, [])}>
            <div className={cls.ImageContainer}>
                <img className={cls.Image} alt="MineCards" src={logo} />
                <IconBadge className={cls.Icon} tone={IconBadgeTone.GREEN}>
                    <SuccessIcon />
                </IconBadge>
            </div>
            <div className={cls.Text}>
                3...2...1... Открой MineCards с главного экрана{' '}
            </div>
        </div>
    )
}
